import { createFileRoute } from "@tanstack/react-router";

import { MASTODON_TIMING_FAQS } from "@/components/marketing/mastodon-timing-faqs";
import { MastodonTimingTool } from "@/components/marketing/mastodon-timing-tool";
import { toolPageHead } from "@/lib/seo";

/**
 * `head` is never code-split, so it must not reach into the component module —
 * that would drag the whole tool into the shared entry chunk. The FAQs live in
 * their own module for exactly this reason; see `mastodon-timing-faqs.ts`.
 */
export const Route = createFileRoute("/(public)/tools/mastodon-best-time")({
  head: () => toolPageHead("mastodonBestTime", MASTODON_TIMING_FAQS),
  component: MastodonTimingTool,
});
